import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import AdSpendVolumeFilter from "../../components/filters/AdSpendVolumeFilter/AdSpendVolumeFilter";
import AdSpendVolumeFilterResult from "../../components/filters/AdSpendVolumeFilter/AdSpendVolumeFilterResult";
import { AdSpendVolumeUpgradeView } from "../../components/filters/AdSpendVolumeFilter/AdSpendVolumeUpgradeView";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineDescriptionFilter } from "../defineSourcedFilter";

import FindAdSpendVolumeFilter from "./AdSpendVolumeFilter";

export const adSpendVolumeDefinition = defineDescriptionFilter({
    key: "adSpendVolume",
    apiCategory: leadsFilterApiCategory.adSpendVolume,
    category: leadsFilterCategoryMap.advertiserActivity,
    trackingName: "Ad Spend Volume",
    titleKey: { key: "si.lead_gen_filters.ad_spend_volume.name" },

    render: ({ description }) => ({
        tooltipText: { key: "si.lead_gen_filters.ad_spend_volume.tooltip" },
        filter: new FindAdSpendVolumeFilter({ options: description.adIntelligence }),
        filterView: AdSpendVolumeFilter,
        filterResultView: AdSpendVolumeFilterResult,
        gateStatus: salesSettingsHelper.isSIAdIntelligenceEnabled
            ? undefined
            : { type: "upgrade", view: AdSpendVolumeUpgradeView },
    }),
});
